// extracted by mini-css-extract-plugin
module.exports = {"warning":"DeleteProfileModal_warning__182_4","buttonContainer":"DeleteProfileModal_buttonContainer__34h7Z"};